import createReducer from 'shared/utils/createReducer';
import requestStatuses from 'modules/common/constants/requestsStatuses';

import { SUBMIT_OTP_FORM } from 'modules/auth/actions/otpForm';
import { LOGOUT } from 'modules/auth/actions/logout';
import { SET_ROUTE_TO_REDIRECT, RESET_ROUTE_TO_REDIRECT } from 'modules/auth/actions/redirect';
import { FETCH_ORGANIZATIONS } from 'modules/auth/actions/fetchOrganizations';
import { GET_SESSION_INFO } from 'modules/session/actions/getSessionInfo';

const defaultState = {
  status: '',
  routeToRedirect: null,
};

export default createReducer(defaultState, {
  [SUBMIT_OTP_FORM.success]: (state) => ({
    ...state,
    status: requestStatuses.success,
  }),

  [LOGOUT.success]: (state) => ({
    ...state,
    status: '',
  }),

  [SET_ROUTE_TO_REDIRECT]: (state, { payload: { routeToRedirect } }) => ({
    ...state,
    routeToRedirect,
  }),

  [RESET_ROUTE_TO_REDIRECT]: state => ({
    ...state,
    routeToRedirect: defaultState.routeToRedirect,
  }),

  [GET_SESSION_INFO.success]: (state) => ({
    ...state,
    routeToRedirect: defaultState.routeToRedirect,
  }),

  [FETCH_ORGANIZATIONS.pending]: (state) => ({
    ...state,
    status: '',
  }),
});
